import { breakPoints } from '@ovpn-ui/styles';
import { darkTheme } from '@ovpn-ui/navigation';

type Theme = {
    itemActiveColor: string;
    itemActiveHoverColor: string;
    itemHoverColor: string;
    bg: string;
    border: string;
    text: string;
    flyoutBg: string;
    flyoutSubItemBg: string;
    flyoutSubItemHover: string;
    mobileBreakpoint: number;
    tabletBreakpoint: number;
};
export const sidebarTheme: Theme = {
    ...darkTheme,
    mobileBreakpoint: breakPoints.SM,
    tabletBreakpoint: breakPoints.MD,
} as const;
